var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"large":"","title":"Detalhes"}},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"hide-filters":"","hide-pagination":"","thead-class":"d-none"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }